const indexItems = [
  {
    title: '热血巅峰：JUMP系超人气连载',
    desc: '咒术回战、海贼王、坂本日常等JUMP王牌作品一站式追更',
    img: 'https://readdy.ai/api/search-image?query=Dynamic%20anime%20action%20scene%20illustration%2C%20Japanese%20shonen%20manga%20style%2C%20warm%20orange%20and%20coral%20accents%2C%20energetic%20composition%2C%20speed%20lines%2C%20professional%20comic%20art%2C%20epic%20battle%20atmosphere&width=600&height=400&seq=index-manga-01&orientation=landscape',
    alt: 'JUMP系超人气连载 热血漫画',
    tag: '热血',
  },
  {
    title: '甜蜜物语：恋爱漫画心动合集',
    desc: '从校园初恋到成人恋爱，治愈系与虐心系一网打尽',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20couple%20illustration%20with%20cherry%20blossoms%2C%20soft%20warm%20peach%20tones%2C%20Japanese%20shojo%20manga%20style%2C%20dreamy%20atmosphere%2C%20gentle%20color%20palette%2C%20beautiful%20composition&width=600&height=400&seq=index-manga-02&orientation=landscape',
    alt: '恋爱漫画心动合集 甜蜜物语',
    tag: '恋爱',
  },
  {
    title: '悬疑剧场：烧脑推理名作精选',
    desc: '死亡笔记、怪物、约定的梦幻岛等智斗悬疑经典全收录',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20dark%20anime%20illustration%20with%20dramatic%20lighting%2C%20Japanese%20suspense%20manga%20style%2C%20warm%20umber%20and%20golden%20accents%2C%20noir%20atmosphere%2C%20intricate%20details%2C%20cinematic%20composition&width=600&height=400&seq=index-manga-03&orientation=landscape',
    alt: '悬疑推理名作 烧脑漫画精选',
    tag: '悬疑',
  },
  {
    title: '异世界之旅：奇幻冒险大集合',
    desc: '转生、魔法、冒险——最受欢迎的异世界题材漫画都在这里',
    img: 'https://readdy.ai/api/search-image?query=Fantasy%20anime%20world%20illustration%20with%20magical%20elements%2C%20Japanese%20isekai%20manga%20style%2C%20warm%20golden%20and%20emerald%20tones%2C%20epic%20landscape%2C%20adventurous%20atmosphere%2C%20detailed%20environment%20art&width=600&height=400&seq=index-manga-04&orientation=landscape',
    alt: '异世界奇幻冒险 漫画合集',
    tag: '奇幻',
  },
  {
    title: '爆笑工坊：笑到停不下来的喜剧',
    desc: '日常搞笑、校园喜剧、无厘头幽默——快乐就在每一页',
    img: 'https://readdy.ai/api/search-image?query=Funny%20anime%20comedy%20illustration%20with%20exaggerated%20expressions%2C%20Japanese%20gag%20manga%20style%2C%20warm%20yellow%20and%20cream%20tones%2C%20playful%20atmosphere%2C%20dynamic%20character%20poses%2C%20bright%20cheerful%20composition&width=600&height=400&seq=index-manga-05&orientation=landscape',
    alt: '搞笑喜剧漫画 爆笑工坊',
    tag: '搞笑',
  },
  {
    title: '新番速递：2026夏季最新连载',
    desc: '本季新上线的热门连载一网打尽，追新不再迷路',
    img: 'https://readdy.ai/api/search-image?query=Fresh%20anime%20summer%20theme%20illustration%2C%20Japanese%20modern%20manga%20style%2C%20vibrant%20warm%20coral%20and%20sky%20tones%2C%20youthful%20energetic%20atmosphere%2C%20summer%20vibes%2C%20clean%20contemporary%20design&width=600&height=400&seq=index-manga-06&orientation=landscape',
    alt: '2026夏季新番速递 最新连载',
    tag: '新番',
  },
  {
    title: '经典神作：永不过时的漫画殿堂',
    desc: '龙珠、灌篮高手、钢之炼金术师——每部都值得一读再读',
    img: 'https://readdy.ai/api/search-image?query=Nostalgic%20classic%20anime%20illustration%20with%20retro%20vibe%2C%20Japanese%20legendary%20manga%20style%2C%20warm%20sepia%20and%20cream%20tones%2C%20timeless%20atmosphere%2C%20iconic%20character%20silhouettes%2C%20artistic%20composition&width=600&height=400&seq=index-manga-07&orientation=landscape',
    alt: '经典神作漫画 永不过时的殿堂',
    tag: '经典',
  },
];

export default function Index() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-2 text-center">
          专题合集
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">精选专题，总有一款适合你</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {indexItems.slice(0, 3).map((item, i) => (
            <div key={i} className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:ring-2 hover:ring-primary-200">
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4">
                <span className="inline-block px-2 py-0.5 rounded bg-primary-100 text-primary-700 text-[10px] font-semibold mb-2">{item.tag}</span>
                <h3 className="font-heading font-bold text-sm text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
          {indexItems.slice(3).map((item, i) => (
            <div key={i + 3} className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:ring-2 hover:ring-primary-200">
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4">
                <span className="inline-block px-2 py-0.5 rounded bg-primary-100 text-primary-700 text-[10px] font-semibold mb-2">{item.tag}</span>
                <h3 className="font-heading font-bold text-sm text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}